import { render, staticRenderFns } from "./BookTextTypeSelect.vue?vue&type=template&id=333f899d&"
import script from "./BookTextTypeSelect.vue?vue&type=script&lang=js&"
export * from "./BookTextTypeSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports